import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import {
  FloatingControlComponent,
  FormControlComponent
} from "../FormComponent";
import { formatInputDate, hoursDifference } from "../../utils/Time";
import {
  formatDate,
  formatDateTime,
  formatSplitKey,
  formatTime,
  plusStringValue
} from "../../commons/FormatValue";
import Table from "../Table";
import PrintButton from "../PrintButton";
import ReportHeadComponent from "../ReportHeadComponent";
import CardDisplayComponent from "../CardDisplayComponent";
import PaginationComponent from "../PaginationComponent";

const PreviewIssueRepairPrintForm = () => {
  const navigate = useNavigate();
  const canvasRef = useRef(null);
  const { user } = useAuth();
  const { state } = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState({
    Item: [],
    Standard: [],
    Sperepart: [],
    Record: [],
    Special: []
  });
  const currentDate = formatDateTime(new Date().toISOString());
  const Repair =
    state?.data?.Item.length > 0
      ? state?.data?.Item.map((item) => ({
          ...state?.data?.Repair,
          Item: item,
          Printed_By: user?.username,
          Printed_Date_Time: currentDate
        }))
      : [
          {
            ...state?.data?.Repair,
            Item: null,
            Printed_By: user?.username,
            Printed_Date_Time: currentDate
          }
        ];
  const currentData = Repair?.[currentPage - 1];
  const inputField = {
    headerReport: [
      { name: "seq_repair_no", label: "เลขที่ใบสั่งงาน", size: 12 },
      {
        name: "ref_cus_ticket_no",
        label: "หมายเลขงานลูกค้า (Ticket)",
        size: 12
      }
    ],
    Repair: [
      {
        name: "inform_repair_items.concern_customer_items.Cus_Code",
        label: "รหัสลูกค้า"
      },
      {
        name: "inform_repair_items.concern_customer_items.Cus_Name",
        label: "ชื่อลูกค้า",
        size: 6
      },
      {
        name: "seq_repair_date",
        label: "วันที่",
        size: "1_5",
        format: (value) => formatDate(value)
      },
      {
        name: "seq_repair_date",
        label: "เวลา",
        size: "1_5",
        format: (value) => formatTime(value)
      },
      {
        name: "inform_repair_items.sub_cus_items.Cus_NumBranch",
        label: "เลขที่สาขา"
      },
      {
        name: "inform_repair_items.sub_cus_items.Cus_Name",
        label: "ชื่อสาขา",
        size: 6
      },
      {
        name: "inform_repair_items.concern_customer_items.Cus_ContactName",
        label: "ผู้ติดต่อ/ตำแหน่ง"
      },
      {
        name: "inform_repair_items.concern_customer_items",
        label: "สถานที่ตั้ง",
        size: 9,
        plusString: [
          "Cus_Road",
          "Cus_District",
          "Cus_SubDistrict",
          "Cus_Province",
          "Cus_ZipCode"
        ]
      },
      {
        name: "inform_repair_items.concern_customer_items.Cus_ContactTel",
        label: "มือถือ"
      },
      {
        name: "job_start_date",
        label: "วันเข้างาน",
        size: "2_25",
        format: (value) => formatDate(value)
      },
      {
        name: "job_start_date",
        label: "เวลา",
        size: "2_25",
        format: (value) => formatTime(value)
      },
      {
        name: "job_end_date",
        label: "วันเข้างาน",
        size: "2_25",
        format: (value) => formatDate(value)
      },
      {
        name: "job_end_date",
        label: "เวลา",
        size: "2_25",
        format: (value) => formatTime(value)
      },
      { name: "inform_repair_items.project_no", label: "เลขที่โครงการ" },
      {
        name: "inform_repair_items.job_type_items.Job_Type_Name",
        label: "ประเภทงาน",
        size: "4_5"
      },
      {
        name: "inform_repair_items.job_type_sub_items.Job_Type_Sub_Name",
        label: "ปรเภทงานย่อย",
        size: "4_5"
      },
      { name: "inform_repair_items.service_call", label: "Service Call" },
      {
        name: "inform_repair_items.cus_direct_tex",
        label: "คำสั่งเพิ่มเติม (ลูกค้า)",
        size: 9
      },
      {
        name: "inform_repair_items.seq_pm_no",
        label: "อ้างอิงเลขที่ใบสั่งงาน PM"
      },
      {
        name: "inform_repair_items.cus_data_tex",
        label: "ข้อมูลที่ได้รับแจ้ง (ลูกค้า)",
        size: 12
      },
      {
        name: "inform_repair_items.condi_work_tex",
        label: "เงื่อนไขในการทำงาน",
        size: 9
      },
      {
        name: "inform_repair_items.inform_doc_status",
        label: "สถานะงานใบแจ้งงาน"
      }
    ],
    Conditions: [
      {
        name: "inform_repair_items.condi_work_tex",
        label: "เงื่อนไขในการทำงาน",
        size: 4
      },
      {
        name: "inform_repair_items.condi_work_type",
        label: "งานที่มี PM/ไม่มี PM (ในเดือน)",
        size: 4,
        format: (v) => `${v !== "" ? (v === "PM" ? "มี PM" : "ไม่มี PM") : ""}`
      },
      {
        name: "inform_repair_items.Seq_Pm_No",
        label: "เลขที่ใบสั่งงาน",
        size: 4
      }
    ],
    Closure: [
      { name: "ฟ", label: "หมายเลขอ้างอิง", size: 6 },
      { name: "ฟ", label: "วันที่ปิดงาน", size: 6 },
      { name: "ฟ", label: "หมายเลขงาน", size: 6 },
      { name: "ฟ", label: "เวลาปิดงาน", size: 6 }
    ],
    Tech: [
      {
        name: " ",
        className: { input: "border-0 border-top rounded-0" },
        size: 12,
        value: "1."
      },
      {
        name: " ",
        className: { input: "border-0 border-top rounded-0" },
        size: 12,
        value: "2."
      },
      {
        name: " ",
        className: { input: "border-0 border-top rounded-0" },
        size: 12,
        value: "3."
      },
      {
        name: " ",
        className: { input: "border-0 border-top rounded-0" },
        size: 12,
        value: "4."
      },
      {
        name: " ",
        className: { input: "border-0 border-top rounded-0" },
        size: 12,
        value: "5."
      },
      {
        name: " ",
        className: { input: "border-0 border-top rounded-0" },
        size: 12,
        value: "6."
      },
      {
        name: " ",
        className: { input: "border-0 border-top border-bottom rounded-0" },
        size: 12,
        value: "7."
      }
    ],
    Other: [
      { name: "Printed_By", label: "พิมพ์โดย" },
      { name: "Printed_Date_Time", label: "วัน/เวลาที่พิมพ์" },
      { name: "Printed_Date_Time", label: "จำนวนครั้งที่พิมพ์" }
    ]
  };
  const columns = {
    Item: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "82px" },
      { name: "รหัสอุปกรณ์", selector: (row) => row?.repair_items?.Item_Code },
      {
        name: "รายละเอียดอุปกรณ์",
        selector: (row) => row?.repair_items?.Item_Name_TH,
        grow: 1.75
      },
      { name: "อาการที่ได้รับแจ้ง", selector: (row) => row?.inform_des },
      {
        name: "จน.ชม.ช่างทำงาน (DT)",
        selector: (row) => row?.dt_mas_items?.DT_Hrs
      },
      {
        name: "วัน/เวลา/ครบกำหนด",
        selector: (row) => row?.date_completed,
        format: ({ dt_mas_items, date_completed }) => {
          if (dt_mas_items) {
            const { DT_Hrs } = dt_mas_items;
            const d = new Date(date_completed);
            const hourDiff = hoursDifference(d, DT_Hrs)?.toISOString();
            const dt = formatInputDate(hourDiff, "ISO").datetime;
            return DT_Hrs ? formatDateTime(dt, "DD/MM/YYYY HH:MM น.") : "";
          }
        }
      }
    ],
    Standard: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "82px" },
      { name: "ขั้นตอนการปฏิบัติงาน", selector: (row) => row },
      { name: "Priority", selector: (row) => row },
      { name: "เหตุผลที่ข้ามขั้นตอน", selector: (row) => row },
      { name: "วันที่ปฏิบัติงาน", selector: (row) => row },
      { name: "ถ่ายรูป", selector: (row) => row },
      { name: "รูปภาพ", selector: (row) => row },
      { name: "หมายเหตุ", selector: (row) => row }
    ],
    Sperepart: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "82px" },
      { name: "รหัสอุปกรณ์/อะไหล่", selector: (row) => row },
      { name: "Model Number", selector: (row) => row },
      { name: "Barcode", selector: (row) => row },
      { name: "สถานะชุดกรอง", selector: (row) => row },
      { name: "วันที่เปลี่ยนล่าสุด", selector: (row) => row },
      { name: "วันหมดอายุ", selector: (row) => row },
      { name: "Priority", selector: (row) => row },
      { name: "เหตุผลที่ข้ามขั้นตอน", selector: (row) => row },
      { name: "วันที่เปลี่ยน", selector: (row) => row },
      { name: "วันที่เปลี่ยนครั้งถัดไป", selector: (row) => row },
      { name: "ถึงวันที่", selector: (row) => row },
      { name: "สถานะชุดกรอง", selector: (row) => row }
    ],
    Record: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "82px" },
      { name: "ขั้นตอนการปฏิบัติงาน", selector: (row) => row },
      { name: "ค่า", selector: (row) => row },
      { name: "หน่วย", selector: (row) => row },
      { name: "Priority", selector: (row) => row },
      { name: "เหตุผลที่ข้ามขั้นตอน", selector: (row) => row },
      { name: "วันที่ปฏิบัติงาน", selector: (row) => row },
      { name: "ถ่ายรูป", selector: (row) => row },
      { name: "รูปภาพ", selector: (row) => row },
      { name: "หมายเหตุ", selector: (row) => row }
    ],
    Special: [
      { name: "ลำดับ", selector: (row) => row?.rowIndex, width: "82px" },
      { name: "รายละเอียดข้อกำหนด", selector: (row) => row },
      { name: "ข้อกำหนดเพิ่มเติมอื่นๆ", selector: (row) => row },
      { name: "รอบ PM", selector: (row) => row },
      { name: "หมายเหตุ", selector: (row) => row }
    ]
  };

  const showData = (field) => {
    return field.map(
      ({ name, label, className, size, format, plusString, value }, idx) => {
        let objValue = formatSplitKey(name, ".", currentData);
        const result =
          (format && format(objValue)) ||
          (plusString && plusStringValue(plusString, " ", objValue)) ||
          value ||
          objValue;

        return (
          <Col
            key={idx}
            sm={size ? size : size === null ? null : 3}
            className="mb-3_5"
          >
            {name && (
              <FloatingControlComponent
                readOnly
                type="text"
                name={name}
                label={label}
                className={className}
                value={result}
              />
            )}
          </Col>
        );
      }
    );
  };

  return (
    <div className="position-relative">
      <PrintButton
        componentRef={canvasRef}
        button={{ style: { zIndex: 10, top: "25px", right: "25px" } }}
      />

      <div ref={canvasRef}>
        <CardDisplayComponent
          body={{
            as: Row,
            className: "mx-4 px-7",
            element: (
              <>
                <Col
                  sm={9}
                  className="ReportHead mb-3 d-flex align-items-center"
                >
                  <ReportHeadComponent formName="Repair notification form" />
                </Col>

                <Col sm={3} as={Row} className="ms-0 px-0">
                  {showData(inputField.headerReport)}
                </Col>

                {showData(inputField.Repair)}
              </>
            )
          }}
        />
        <CardDisplayComponent
          header={{
            className: "mx-4 px-7",
            title: { text: "รายละเอียดอุปกรณ์ที่แจ้งซ่อม" }
          }}
          body={{
            className: "mx-4 px-7",
            element: <Table data={[currentData?.Item]} column={columns.Item} />
          }}
        />
        <CardDisplayComponent
          header={{
            className: "mx-4 px-7",
            title: { text: "ขั้นตอนปฏิบัติงานตามมาตรฐาน" }
          }}
          body={{
            className: "mx-4 px-7",
            element: <Table data={data.Item} column={columns.Standard} />
          }}
        />
        <CardDisplayComponent
          header={{
            className: "mx-4 px-7",
            title: { text: "รายการตรวจสอบ / เปลี่ยน Sparepart" }
          }}
          body={{
            className: "mx-4 px-7",
            element: <Table data={data.Sperepart} column={columns.Sperepart} />
          }}
        />
        <CardDisplayComponent
          header={{
            className: "mx-4 px-7",
            title: { text: "รายการบันทึกข้อมูล" }
          }}
          body={{
            className: "mx-4 px-7",
            element: <Table data={data.Record} column={columns.Record} />
          }}
        />
        <CardDisplayComponent
          header={{
            className: "mx-4 px-7",
            title: { text: "ข้อกำหนดเพิ่มเติม (คำสั่งพิเศษ)" }
          }}
          body={{
            className: "mx-4 px-7",
            element: <Table data={data.Special} column={columns.Special} />
          }}
        />

        <Row>
          <Col className="pe-1_5">
            <CardDisplayComponent
              header={{
                className: "ms-4 ps-7 pe-0",
                title: { text: "สำหรับการแจ้งปิดงาน" }
              }}
              body={{
                as: Row,
                className: "ms-2_5 ps-7 pe-0",
                element: (
                  <>
                    {inputField.Closure.map(({ name, label }) => (
                      <Col key={name} sm={6} className="mb-3_5">
                        <FloatingControlComponent
                          readOnly
                          type="text"
                          name={name}
                          label={label}
                          value={formatSplitKey(name, ".", currentData)}
                        />
                      </Col>
                    ))}
                    <Card.Subtitle className="mb-3_5 fs-3">
                      หมายเหตุ
                    </Card.Subtitle>
                    {[1, 2, 3].map((item) => (
                      <Col key={item} sm={12} className="mb-3_5">
                        <FloatingControlComponent
                          readOnly
                          type="text"
                          name={item}
                          value={`${item}.`}
                        />
                      </Col>
                    ))}
                    <Col sm={6} className="mt-2_5">
                      <FloatingControlComponent
                        readOnly
                        type="text"
                        name="ผู้ออกใบสั่งงาน"
                        label="ผู้ออกใบสั่งงาน"
                        value={plusStringValue(
                          ["Employee_Name", "Employee_Surname"],
                          " ",
                          currentData?.inform_repair_items?.iss_job_items
                        )}
                      />
                    </Col>
                  </>
                )
              }}
            />
          </Col>

          <Col className="ps-1_5">
            <CardDisplayComponent
              header={{
                className: "me-4 ps-0 pe-7",
                title: { text: "รายชื่อช่างทำงาน" }
              }}
              body={{
                as: Row,
                className: "me-2_5 ps-0 pe-7",
                element: (
                  <>
                    {[1, 2, 3, 4, 5, 6, 7].map((item) => (
                      <Col key={item} sm={12}>
                        <FormControlComponent
                          readOnly
                          type="text"
                          name={item}
                          className={{
                            input: `border-0 border-top rounded-0 ${
                              item === 7 ? "border-bottom" : ""
                            }`
                          }}
                          value={`${item}.`}
                        />
                      </Col>
                    ))}

                    <Col sm={6} className="mt-3_5">
                      <FloatingControlComponent
                        readOnly
                        type="text"
                        name="approve_items"
                        label="ผู้อนุมัติ"
                        value={plusStringValue(
                          ["Employee_Name", "Employee_Surname"],
                          " ",
                          currentData?.inform_repair_items?.approve_items
                        )}
                      />
                    </Col>
                  </>
                )
              }}
            />
          </Col>
        </Row>
        <CardDisplayComponent
          body={{
            as: Row,
            className: "mx-2_5 px-7 justify-content-between",
            element: inputField.Other.map(({ name, label }) => (
              <Col key={name} sm={3}>
                <FloatingControlComponent
                  readOnly
                  type="text"
                  name={name}
                  label={label}
                  value={formatSplitKey(name, ".", currentData)}
                />
              </Col>
            ))
          }}
        />
      </div>

      <CardDisplayComponent
        body={{
          className: "text-center",
          element: (
            <PaginationComponent
              data={Repair}
              currentPage={currentPage}
              itemsPerPage={1}
              onPageChange={(num) => setCurrentPage(num)}
            />
          )
        }}
      />

      <CardDisplayComponent
        footer={{
          className: "text-center",
          element: (
            <Button
              variant="outline-secondary"
              className="px-4 py-2 text-dark rounded-pill"
              onClick={() =>
                navigate("/repair_work/record", { state: { name: "search" } })
              }
            >
              ย้อนกลับ
            </Button>
          )
        }}
      />
    </div>
  );
};

export default PreviewIssueRepairPrintForm;
